export default "__VITE_ASSET__DPaDAj9$__"